import { clsx } from 'clsx';
import { ModalOverlay } from './ModalOverlay';
import { ReactNode } from 'preact/compat';

type ModalProps = {
    width?: string;
    height?: string;
    className?: string;
    children: ReactNode;
};

export const Modal = ({
    className,
    children,
}: ModalProps) => {
    
    return (
        <ModalOverlay>
        <div
            className={clsx(
                'absolute z-50 overflow-hidden w-[90%] h-[90%] rounded-xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
                className
            )}
            data-cmp="Modal"
            role={"dialog"}
            aria-modal={true}
            tabIndex={1}
        >
         {children}
        </div>
        </ModalOverlay>
    );
};
